export default {"src":"/_next/static/media/college2.a6afa1b1.svg","height":72,"width":72,"blurWidth":0,"blurHeight":0};